// Self-contained data for the The Centerpiece — Cebu events concept website.
export const BUSINESS = {
  "slug": "the-centerpiece-cebu-concept",
  "media": {
    "hero": "/events/centerpiece/14.jpg",
    "logo": "/events/centerpiece/15.jpg",
    "gallery": [
      "/events/centerpiece/01.jpg",
      "/events/centerpiece/02.jpg",
      "/events/centerpiece/03.jpg",
      "/events/centerpiece/04.jpg",
      "/events/centerpiece/05.jpg",
      "/events/centerpiece/06.jpg",
      "/events/centerpiece/07.jpg",
      "/events/centerpiece/08.jpg",
      "/events/centerpiece/09.jpg",
      "/events/centerpiece/10.jpg",
      "/events/centerpiece/11.jpg",
      "/events/centerpiece/12.jpg",
      "/events/centerpiece/13.jpg"
    ]
  },
  "name": "The Centerpiece — Cebu",
  "shortName": "The Centerpiece",
  "kind": "planner",
  "layout": "editorial",
  "location": "Cebu City",
  "address": "Verve Point, Gov. M. Cuenco Avenue / Nasipit Road, Cebu City 6000, Philippines",
  "eyebrow": "Wedding planning and direction",
  "headline": "The day reads beautifully because the work behind it is exact.",
  "intro": "A Cebu planning team known publicly for organization, supplier relationships and composed wedding-day execution.",
  "lead": "Roderick Bautista & Eddie Jamin",
  "leadRole": "Event directors",
  "story": "Public industry material strongly associates Roderick Bautista and Eddie Jamin with The Centerpiece as event directors. A 2025 peer-voted Cebu wedding-industry profile ranked the team first among local planners and coordinators.",
  "services": [
    "Wedding planning and coordination",
    "Budget tracking",
    "Design consulting",
    "Venue scouting",
    "Supplier coordination",
    "Setup oversight",
    "Wedding-day execution"
  ],
  "process": [
    "Begin with the couple’s priorities",
    "Build the supplier and venue framework",
    "Track design, budget and production details",
    "Direct the day with care for clients and suppliers"
  ],
  "proof": [
    "Peer-ranked in a 2025 Cebu industry profile",
    "Strong supplier relationships",
    "Repeated overseas-client recommendations"
  ],
  "reviewSnapshot": "A public directory listed about 5.0/5 from 7 reviews when checked in August 2026, supported by wider community and supplier discussion.",
  "reviews": [
    {
      "author": "Graduate bride",
      "summary": "Described a hands-on team that handled concerns quickly, arranged supplier meetings and made planning and execution considerably less stressful.",
      "source": "https://www.reddit.com/r/CebuWeddings/comments/1nt6qhr/need_advice_on_cebu_wedding_planners_and_suppliers/",
      "explicitStars": null,
      "context": "Planning story"
    },
    {
      "author": "Overseas couple",
      "summary": "Described their November 2025 Cebu wedding experience as stress-free and highly recommendable.",
      "source": "https://www.reddit.com/r/CebuWeddings/comments/1qhcpcq/wedding_plannercoordinator_reviews/",
      "explicitStars": null,
      "context": "Planning from abroad"
    },
    {
      "author": "Wedding supplier",
      "summary": "Praised the coordinators as proactive, prepared and attentive to both couples and suppliers.",
      "source": "https://www.reddit.com/r/CebuWeddings/comments/1sm0ef0/reviews_of_our_wedding_suppliers/",
      "explicitStars": 5,
      "context": "Supplier perspective"
    },
    {
      "author": "Current client",
      "summary": "Reported generally good communication and said the requested design direction was followed, while another client in the same discussion raised slower assistant group-chat replies.",
      "source": "https://www.reddit.com/r/CebuWeddings/comments/1ro0jqm/the_centerpiece_experience/",
      "explicitStars": null,
      "context": "Balanced community record"
    }
  ],
  "contact": {
    "email": "info.thecenterpiece@gmail.com",
    "instagram": "https://www.instagram.com/thecenterpiece"
  },
  "sources": [
    "https://cebuweddingsuppliers.com/top-10-cebu-wedding-planners-and-coordinators-2025/",
    "https://cebuweddingsuppliers.com/listing/the-centerpiece/",
    "https://www.instagram.com/thecenterpiece",
    "https://www.reddit.com/r/CebuWeddings/comments/1ro0jqm/the_centerpiece_experience/"
  ]
};
